@if (!loading() && data().data.length === 0) {
  <div role="status" class="w-full flex items-center justify-center p-4">
    No History found
  </div>
} @else {
  <custom-table id="quote-history-component" [columns]="columns()" [data]="data()" [loading]="loading()"
                primaryDataKey="history_id" [usePagination]="false" [visibleHeader]="false"/>
}

<ng-template #actionDescriptionColumn let-row>
  <div [innerHTML]="row[HistoryColumn.ActionDescription]"></div>
</ng-template>
<ng-template #userNameColumn let-row>
  <div class="flex flex-wrap gap-1 items-center">
    @if (row[HistoryColumn.UserName].trim() === systemUser) {
      <span
        class="px-2 py-0.5 bg-[#fdde64] dark:bg-yellow-500 text-black dark:text-gray-900 rounded-full text-sm whitespace-nowrap">
              {{ row[HistoryColumn.UserName] }}
            </span>
    } @else {
      <span class="break-words">{{ row[HistoryColumn.UserName] }}</span>
    }
    @if (row[HistoryColumn.RoleName] !== hiddenRole) {
      <span
        class="px-2 py-0.5 bg-[#fdde64] dark:bg-yellow-500 text-black dark:text-gray-900 rounded-full text-sm whitespace-nowrap">
              {{ row[HistoryColumn.RoleName] }}
            </span>
    }
  </div>
</ng-template>
<ng-template #emailColumn let-row>
  <a [href]="'mailto:' + row[HistoryColumn.Email]" class="text-blue-500 dark:text-blue-400">
    {{ row[HistoryColumn.Email] }}
  </a>
</ng-template>
